import { render } from "./Menu.vue?vue&type=template&id=5567115e&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=5567115e&scoped=true&lang=css"

import exportComponent from "/Users/alexis/Desktop/Software/grupo_albarran_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5567115e"]])

export default __exports__